<template>
	<div>
		<div class="wrap" v-if="isMobile">

			<div class="msignUp">
                <h2><span>在线报名</span></h2>

				<div class="item">
                	<div class="label-item">报名来源：</div>
					<div class="input-item">
					<el-select size="small" v-model="channel" :class="msg==''?'el-select-ts':'el-select-ts red'" placeholder="选择报名来源" @change="VerifyChannel()">
						<el-option label="代练APP" value="代练APP"></el-option>
						<el-option label="高校" value="高校"></el-option>
						<el-option label="其他来源" value="其他来源"></el-option>
					</el-select><div class="msg">{{msg}}</div></div>
				</div>
				<div class="item">
                	<div class="label-item">报名类型：</div>
					<div class="input-item">
					<!-- <el-select size="small" v-model="level" @change="changeType()">
						<el-option label="初级" value="初级"></el-option>
					</el-select> -->

					<el-select size="small" v-model="level" @change="changeType()" >
						<el-option v-for="item in levelArr" :key="item" :label="item" :value="item"></el-option>
					</el-select>

					<el-select size="small" v-model="gameId" @change="changeGame()" :class="msg1==''?'':'red'" >
						<el-option v-for="item in gameArr" :key="item.GameID" :label="item.Game" :value="item.GameID"></el-option>
					</el-select>
					<div class="msg1">{{msg1}}</div>
					</div>
				</div>

				<div class="item">
                	<div class="label-item">报名内容：</div>
					<div class="input-item sut" v-html="content"></div>
				</div>

				<div class="item" v-if="realName">
                	<div class="label-item">用户信息：</div>
					<div class="input-item sut">
						姓名：{{realName}}<br/>
						{{cardType}}：{{idcard}}
					</div>
				</div>

				<div class="item">
                	<div class="label-item">报名费用：</div>
					<div class="input-item sut">
						{{bal}}元
					</div>
				</div>

				<div class="item">
                	<div class="label-item">认定条件：</div>
					<div class="input-item">
						<i @click="AgreeProtocol()" :class="isAgree?'icon3 icon3-checkbox-checked':'icon3 icon3-checkbox'" ></i>
						<div class="popover-ques">确定我已年满18周岁
						<em class="icon3 icon3-question" slot="reference" @click="showQue"></em>
						</div>
					</div>
				</div>

				<div class="item">
					<template v-if="isAgree">
						 <el-button @click="baoming()" type="primary" >报 名</el-button>
					</template>
					<template v-else>
						 <el-button type="info"  plain>报 名</el-button>
					</template>
				</div>
				<div class="item ques" @click="showExample1">
					认证后会享受什么福利？
				</div>
            </div>

			<!-- 支付 -->
			<pay :Bal="bal" :ID="id" :GameID="gameId" :Game="levelGame" :IsMySignUpPage="IsMySignUpPage" :isShow="isShowWindow" @on-close="closeWindow" ></pay>

		</div>
		<div class="content" v-else>
            <div class="signUp">
                <h2>
					<span>在线报名</span>

				</h2>



				<div class="item">
                	<div class="label-item">报名来源：</div>
					<div class="input-item">
					<el-select size="small" v-model="channel" :class="msg==''?'el-select-ts':'el-select-ts red'" placeholder="选择报名来源" @change="VerifyChannel()">
						<el-option label="代练APP" value="代练APP"></el-option>
						<el-option label="高校" value="高校"></el-option>
						<el-option label="其他来源" value="其他来源"></el-option>
					</el-select><div class="msg">{{msg}}</div></div>
				</div>
				<div class="item">
                	<div class="label-item">报名类型：</div>
					<div class="input-item">
					<!-- <el-select size="small" v-model="level" @change="changeType()">
						<el-option label="初级" value="初级"></el-option>
					</el-select> -->

					<el-select size="small" v-model="level" @change="changeType()" >
						<el-option v-for="item in levelArr" :key="item" :label="item" :value="item"></el-option>
					</el-select>

					<el-select size="small" v-model="gameId" @change="changeGame()" :class="msg1==''?'':'red'" >
						<el-option v-for="item in gameArr" :key="item.GameID" :label="item.Game" :value="item.GameID"></el-option>
					</el-select>
					<div class="msg1">{{msg1}}</div>
					</div>
				</div>

				<div class="item">
                	<div class="label-item">报名内容：</div>
					<div class="input-item sut" v-html="content"></div>
				</div>

				<div class="item" v-if="realName">
                	<div class="label-item">用户信息：</div>
					<div class="input-item sut">
						姓名：{{realName}}<br/>
						{{cardType}}：{{idcard}}
					</div>
				</div>

				<div class="item">
                	<div class="label-item">报名费用：</div>
					<div class="input-item sut">
						{{bal}}元
					</div>
				</div>

				<div class="item">
                	<div class="label-item">认定条件：</div>
					<div class="input-item">
						<i @click="AgreeProtocol()" :class="isAgree?'icon3 icon3-checkbox-checked':'icon3 icon3-checkbox'" ></i>
						<div class="popover-ques">
							确定我已年满18周岁
						<el-popover
							popper-class="popover"
							placement="bottom"
							title="提示"
							width="320"
							trigger="hover"
							content="报名之后无法退款，请达到认定条件后在进行报名。"
							v-model="visible">
							<em class="icon3 icon3-question" slot="reference" ></em>
						</el-popover>
						</div>
					</div>
				</div>

				<div class="item">
					<template v-if="isAgree">
						 <el-button @click="baoming()" type="primary" size="small">报 名</el-button>
					</template>
					<template v-else>
						 <el-button type="info" size="small" plain>报 名</el-button>
					</template>
				</div>
				<div class="item ques" @click="showExample">
					认证后会享受什么福利？
				</div>
            </div>

			<!-- 支付 -->
			<pay :Bal="bal" :ID="id" :GameID="gameId" :Game="levelGame" :IsMySignUpPage="IsMySignUpPage" :isShow="isShowWindow" @on-close="closeWindow" ></pay>
        </div>
	</div>


</template>
<style scoped>
.signUp{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom: 50px; }

.signUp .item{text-align: center; padding-bottom:24px; color:#8c8c8c; line-height: 28px;}
.signUp .label-item{ width:40%;display: inline-block; text-align: right; }
.signUp .input-item{width:58%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.signUp .input-item i{ margin-top:0.3rem; margin-right:0.2rem;}
.signUp input{height:20px;}
.signUp .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.signUp .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}
.signUp .popover-ques{ width:190px;}

.signUp h2{ height:68px; line-height:68px; font-size:24px; padding-left:421px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal; margin-bottom: 50px;}
.signUp h2 span{ float:left;}
.signUp em{ float:right; margin-top:6px;}
.signUp .ques{ color:#1890ff; cursor: pointer;}

.msignUp{background:#fff; overflow:hidden; margin:16px 0; font-size:14px; padding-bottom: 50px; }
.msignUp .item{text-align: center; padding:12px 0; color:#8c8c8c; line-height: 28px; }
.msignUp .label-item{ width:20%;display: inline-block; text-align: right; }
.msignUp .input-item{width:75%; display: inline-block; text-align: left; font-size:16px;color:#111; }
.msignUp .input-item i{ margin-top:0.5rem; margin-right:0.5rem;}
.msignUp input{height:20px;}
.msignUp .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.msignUp .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; padding-left:135px;}

.msignUp h2{ height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center; margin-bottom: 2rem;}

.msignUp em{ float: right;margin-top:0.5rem; }
.msignUp .ques{ color:#1890ff; cursor: pointer;}

.msignUp button{width:90%;}
.msignUp .popover-ques{ width:17rem;}

</style>
<script>
	import pay from "../components/pay"
	export default {
		name: 'signUp',
		components: {pay:pay},
		methods: {
			showExample()
			{
				var src="/static/images/CertificateExample.png";
				this.$alert('<div class="fuli"><dl><dd><img src="'+src+'" width="100%" /></dd><dt><h3>认证后会享受什么福利？</h3>由协会颁发实体证书，且支持网上人才查询，真正做到技能认证，持证上岗。包括在<a href="http://www.dailiantong.com/" target="_blank">代练通</a>平台，享受以下特权： </dt></dl><div class="clear"></div><ul><li><em>·</em>每天赠送10元现金券，连领30天，累计300元</li> <li><em>·</em>首绑直升一周期（15天左右）中级代练资格，接手更好订单</li> <li><em>·</em>降低要求，每个周期更快更容易升级到中/高级代练</li> <li><em>·</em>享受保级特权，获得半永久中代资格</li><li><em>·</em>升级高代后每日优选订单可抢接数量+1</li><li><em>·</em>专属游戏代练师徽章（与普通代练一眼区分）</li><li><em>·</em>更多特权持续开放中</li></ul></div>', '', {
					dangerouslyUseHTMLString: true,
					showClose:true,
					confirmButtonText:"知道了",
					confirmButtonClass:"fr",
					customClass:'fuli-message-box'
				}).catch(() => {
                });
			},
			showExample1()
			{
				var src="/static/images/CertificateExample.png";
				this.$alert('<div class="mfuli"><div><p><img src="'+src+'" width="100%" /></p><p>由协会颁发实体证书，且支持网上人才查询，真正做到技能认证，持证上岗。包括在<a href="http://www.dailiantong.com/" target="_blank">代练通</a>平台，享受以下特权：</p></div><div class="clear"></div><ul><li><em>·</em>	每天赠送10元现金券，连领30天，累计300元</li> <li><em>·</em>首绑直升一周期（15天左右）中级代练资格，接手更好订单</li> <li><em>·</em>降低要求，每个周期更快更容易升级到中/高级代练</li> <li><em>·</em>享受保级特权，获得半永久中代资格</li><li><em>·</em>升级高代后每日优选订单可抢接数量+1</li><li><em>·</em>专属游戏代练师徽章（与普通代练一眼区分）</li><li><em>·</em>更多特权持续开放中</li></ul></div>', '', {
					dangerouslyUseHTMLString: true,
					showClose:true,
					confirmButtonText:"知道了",
					confirmButtonClass:"fr",
					customClass:'mfuli-message-box'
				}).catch(() => {
                });
			},
			showQue(){
				this.$alert("报名之后无法退款，请达到认定条件后在进行报名。", '提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
			},
			typeList(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("TypeSetting?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						self.typeArr=res.Result;
						self.setLevelData();
						self.changeType();
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}
					},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			myInfo(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("GetMyIDCard?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						var arr=res.Result;
						if(arr.length==0){
							// self.$alert('请先完成实名认证', '', {
							// confirmButtonText: '实名认证',
							// type:"info",
							// showClose:false,
							// callback: action => {
							// 	self.$router.push({path:'/auth'});
							// }
							// });
							self.realName='';
							self.idcard='';
							self.cardType='';
						}else{
							self.realName=arr[0].RealName;
							self.idcard=arr[0].IDCard;
							self.cardType=self.changeType1(arr[0].Type);
						}
					}else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}
					},function(err){
					self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			},
			changeType(){
				this.setGameData();
				this.changeGame();
			},
			changeGame(){
				if(this.gameId!=''){
					this.msg1="";
					var obj=this.getType(this.level,this.gameId);
					if(obj){
						this.content=obj.WrittenTestCount+" 次《"+this.level+"游戏代练师技能认定》笔试机会<br/>"+obj.OperationCount+" 次《"+this.level+"游戏代练师技能认定》实操预约机会";
						this.bal=obj.Bal;

						for(var i=0;i<this.gameArr.length;i++){
							if(this.gameArr[i].GameID==this.gameId){
								this.levelGame=this.gameArr[i].Game;
								break;
							}
						}

					}else{
						this.$alert("没有对应的等级和游戏", '错误', {confirmButtonText: '确定'});
					}
				}else{
					this.msg1="请选择游戏";
				}
			},
			getType(name,gameId){
				var arr=this.typeArr;
				var obj;
				for(var i=0;i<arr.length;i++){
					if(arr[i].Level==name && arr[i].GameID==gameId){
						obj=arr[i];
						break;
					}
				}
				return obj;
			},
			getGameById(id){
				var arr=this.gameArr;
				var game='';
				for(var i=0;i<arr.length;i++){
					if(arr[i].GameID==id){
						game=arr[i].Game;
						break;
					}
				}
				return game;
			},
			VerifyChannel(){
				if(this.channel=="")
					this.msg="请选择报名来源";
				else{
					this.msg="";
				}
			},
			VerifyGame(){
				if(this.gameId=="")
					this.msg1="请选择游戏";
				else{
					this.msg1="";
				}
			},
			changeType1(val){
				if(val==1)
					return "身份证号";
				else if(val==2)
					return "港澳通行证";
				else if(val==3)
					return "台湾通行证";
				else if(val==4)
					return "外国护照";
			},
			showWindow(){
				this.isShowWindow=true;
			},
			closeWindow(val){
				this.isShowWindow=val;
			},
			baoming(){
				const self = this;
				this.VerifyChannel();
				this.VerifyGame();
				var customClass='';
				if(this.gameId!='' && this.channel!=''){

					var game=self.getGameById(self.gameId);
					var gameStr="";
					for(var i=0;i<self.gameArr.length;i++){
						gameStr=gameStr+self.gameArr[i].Game+",";
					}

					if(gameStr!=""){
						gameStr=gameStr.substring(0,gameStr.length-1);
					}

					if(self.isMobile){
						customClass='mfuli-message-box';
					}

					this.$confirm('您确定要报名<font color="red">'+game+'</font>么？您可在报名类型游戏下拉框更换报名游戏，可更换选项：'+gameStr, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass:customClass,
					dangerouslyUseHTMLString:true,
					type: 'warning'
					}).then(() => {

						//报名
						const loading = self.$loading(self.loading);
						var obj=self.getType(self.level,self.gameId);
						var title=self.level+"游戏代练师技能认定-"+game;
						var qudaoObj= self.common.GetlocalStorage("qudao");
						var qudao="";
						if(qudaoObj){
							qudao=JSON.parse(qudaoObj).qudao;
						}

						var imsJson = [{
							"id":0,
							"userId":0,
							"title": title,
							"channel":qudao+self.channel,
							"level":self.level,
							"status":10,
							"gameId":self.gameId,
							"bal":self.bal,
							"writtenTestCount":obj.WrittenTestCount,
							"operationCount":obj.OperationCount
						}];

						var json={"baoming":imsJson }
						self.http.ajaxPost('AddBaoming',json,"",function(data){
							loading.close();
							if(data.ReturnCode == 1){
								if(data.Result>0){
									self.id=data.Result;
									self.showWindow();
								}
								else
									self.$alert("提交失败，请稍后重试", '温馨提示', {confirmButtonText: '确定'});
							}else if(data.ReturnCode == 10){
								//用户没有登录
								self.$router.push({path:'/login'});
							}else if(data.ReturnCode == 11){
								//您有未支付的报名单，请去我的报名继续支付
								if(self.isMobile){
									self.$alert(data.Message, '', {
									confirmButtonText: '去支付',
									customClass:'mfuli-message-box',
									type:"info",
									showClose:false,
									callback: action => {
										//self.$router.push({path:'/my-sign-up'});
										self.id=data.Result;
										self.showWindow();
									}
									});
								}else{
									self.$alert(data.Message, '', {
									confirmButtonText: '去支付',
									type:"info",
									showClose:false,
									callback: action => {
										//self.$router.push({path:'/my-sign-up'});
										self.id=data.Result;
										self.showWindow();
									}
									});
								}
							}else if(data.ReturnCode == 12){
								if(self.isMobile){
									self.$alert(data.Message, '', {
									confirmButtonText: '确定',
									customClass:'mfuli-message-box',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/home'});
									}
									});
								}else{
									self.$alert(data.Message, '', {
									confirmButtonText: '确定',
									type:"info",
									showClose:false,
									callback: action => {
										self.$router.push({path:'/home'});
									}
									});
								}
							}
							else{
								self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
							}
						},function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});

					}).catch(() => {});


				}
			},
			setLevelData(){
				for(var i=0;i<this.typeArr.length;i++){
					var a = this.levelArr.indexOf(this.typeArr[i].Level);
					if(a<0){
						this.levelArr.push(this.typeArr[i].Level);
					}
				}
			},
			setGameData(){
				this.gameArr.length = 0;
				for(var i=0;i<this.typeArr.length;i++){
					if(this.typeArr[i].Level==this.level){
						var obj={"GameID":this.typeArr[i].GameID.toString(),"Game":this.typeArr[i].Game};
						this.gameArr.push(obj);
					}
				}
				this.gameId=this.gameArr[0].GameID.toString();
				this.levelGame=this.gameArr[0].Game.toString();
			},
			AgreeProtocol(){
				const self = this;
				if(self.isAgree){
					self.isAgree=false;
				}else{
					self.isAgree=true;
				}
			},
		},
		data() {
			return {
				msg:'',
				msg1:'',
				selectType:'',
				channel:'',
				level:'初级',
				gameId:'',
				levelGame:'',
				bal:280,
				typeArr:[],
				gameArr:[],
				levelArr:[],
				content:'10 次《初级电竞代练师技能认定》笔试机会<br/>2 次《初级电竞代练师技能认定》实操预约机会',
				realName:'',
				idcard:'',
				cardType:'',
				isShowWindow:false,
				id:0,
				IsMySignUpPage:false,
				Code:'',
				isAgree:false,
				visible:false,
			}
		},
		computed:{
			loading(){
				return this.$store.getters.loadingPara;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			//this.$store.dispatch('isShowWxActions',false);
			this.typeList();
			this.myInfo();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/sign-up.vue